export default {"src":"/_next/static/media/UA.8cb02628.svg","height":18,"width":18};